module.exports = __webpack_public_path__ + "td.0c5287a49a2367969c22.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/td.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/td.svg
// module chunks = styles